import React, { useEffect, useContext, useState, useRef } from 'react'
import { Box } from '@material-ui/core'

import LanguageContext from "../../../contexts/LanguageContext"
import UserContext from "../../../contexts/UserContext"

import SuperAdminContext from "../../../contexts/SuperAdminContext"

import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';

import { TopBar, BottomBar, CenterContainer } from "./FormatsHelpers"

import EditableField from "./EditableField"
import EditableButton from "./EditableButton"

import EditorPopover from "../../ui/Admin/Formations/EditorPopover"
import QuizzHelper from "../../ui/Admin/Formations/FormatHelpers/QuizzHelper"

const FormatQuizz = ({ actFormation, actIndex, format, setViewPlanCours, viewPlanCours, onlyContent, isEditor, sequenceSubMenu, setSequenceSubMenu }) => {

  const { actLanguage, languageValues } = useContext(LanguageContext)

  const { manageFormatResponse, manageSlide } = useContext(UserContext)

  let superAdminContext = null
  if (isEditor) {
    superAdminContext = useContext(SuperAdminContext)
  }


  const [isAlreadyAnswer, setIsAlreadyAnswer] = useState(false)
  const [responses, setResponses] = useState([])
  useEffect(() => {
    if (format?.isDone) {
      setIsAlreadyAnswer(true)
      if (format?.userChoice) {
        setResponses(format?.userChoice)
      } else {
        setResponses([])
      }
    } else {
      setIsAlreadyAnswer(false)
      setResponses([])
    }
  }, [format])

  const handleClick = (item, i) => {
    if (isAlreadyAnswer === false) {
      if (format?.multi) {
        //choix multiple
        let actReps = [...responses]
        let findInActReps = actReps.find((el) => el === i)
        if (findInActReps === undefined) {
          actReps.push(i)
        } else {
          actReps = actReps.filter((el) => el !== i)
        }
        setResponses(actReps.sort())
      } else {
        //une seule réponse possible
        setResponses([i])
      }
    }
  }

  const validQuizz = () => {
    if (isEditor) { return null }

    let userIsValid = 0
    if (format?.noValidAnswer) {
      userIsValid = 1
    } else {
      //on doit controler si c'est valide ou pas
      let haveError = false
      let allReps = format?.responses
      for (let i=0; i<allReps?.length; i++) {
        let thisRep = allReps[i]
        let findInReps = responses.find((el) => el === i)

        if (thisRep?.isValid === true && findInReps === undefined) {
          //bonne réponse mais pas sélectionné
          haveError = true
          break;
        }
        if (thisRep?.isValid === false && findInReps !== undefined) {
          //mauvaise réponse mais sélectionnée
          haveError = true
          break;
        }
      }
      if (haveError === false) {
        userIsValid = 1
      }
    }

    setIsAlreadyAnswer(true)
    manageFormatResponse(format, [{ key: 'isDone', value: true }, { key: 'userChoice', value: responses }, { key: 'userIsValid', value: userIsValid }])
    if (format?.noValidAnswer === true) {
      manageSlide(1)
    }
  }


  return (
    <Box sx={{
      display:"flex",
      flexDirection:"column",
      height:onlyContent?"100%":"100vh",
      overflow:"hidden",
      gap:"10px"
    }}>
      { /* EDITOR ADMIN */}
      {isEditor &&
        <EditorPopover
          open={sequenceSubMenu}
        >
          <QuizzHelper
            format={format}
          />
        </EditorPopover>
      }
      { /* END EDITOR ADMIN */}
      <TopBar
        actFormation={actFormation}
        actIndex={actIndex}
        setViewPlanCours={setViewPlanCours}
        viewPlanCours={viewPlanCours}
        onlyContent={onlyContent}
      />
      <CenterContainer
        actFormation={actFormation}
        actIndex={actIndex}
        onlyContent={onlyContent}
      >
        <Box sx={{
          width:"100%",
          maxHeight:["unset", "unset", "unset", "calc(100vh - 260px)"],
          display:"flex",
          flexDirection:["column", "column", "column", "row"],
          gap:["20px", "40px", "40px", "60px"],
          overflow:["unset", "unset", "unset", "hidden"],
        }}>
          {format?.image?.link &&
            <Box sx={{
              flex: ["unset", "unset", "unset", 0.4],
            }}>
              <Box sx={{
                background:"white",
                width:"100%",
                border:"1px solid black",
                height:["250px", "400px", "400px", "unset"],
                aspectRatio:["unset", "unset", "unset", "520/450"],
                backgroundRepeat:"no-repeat",
                backgroundPosition:"center center",
                backgroundImage:"url("+format?.image?.link+")",
                backgroundSize:format?.image?.type === "cover" ? "cover" : "contain",
              }}>
              </Box>
            </Box>
          }
          <Box sx={{
            flex:format?.image ? ["unset", "unset", "unset", 0.6] : ["unset", "unset", "unset", 1],
            overflowX:"hidden",
            overflowY:["hidden", "hidden", "hidden", "auto"],
            display:"flex",
            flexDirection:"column",
          }}>
            <Box sx={{
              margin:'auto 0',
            }}>
              <EditableField
                field={format?.questions}
                type="questions"
                isEditor={isEditor}
                sx={{
                  color:"text.black",
                  fontSize:["26px", "42px", "42px", "46px"],
                  textAlign:format?.image ? ["center", "center", "center", "left"] : "center",
                }}
              />
              {format?.multi === true &&
                <Box sx={{
                  marginTop:["10px", "15px", "15px", "20px"],
                  textAlign:format?.image ? ["center", "center", "center", "left"] : "center",
                  color:"text.subTitle",
                  fontSize:["15px", "18px", "18px", "20px"],
                }}>
                  {languageValues?.formation?.multipleAnswers[actLanguage]}
                </Box>
              }
              <Box sx={{
                marginTop:["20px", "30px", "30px", "50px"],
                display:"flex",
                flexDirection:"column",
                gap:["11px", "14px", "14px", "19px"],
                userSelect:"none",
                alignItems:format?.image ? ["center", "center", "center", "flex-start"] : "center",
              }}>
                {format?.responses?.map((item, i) => {
                  let statut = ""
                  let findInReps = responses.find((el) => el === i)
                  if (isAlreadyAnswer) {
                    if (format?.noValidAnswer !== true) {
                      if (item?.isValid) { //c'est une bonne réponse
                        if (findInReps !== undefined) {
                          //good, sélectionné et bonne réponse (vert)
                          statut = "good"
                        } else {
                          //pas good, pas sélectionné et bonne réponse (orange)
                          statut = "mustBeSelected"
                        }
                      } else { //c'est une mauvaise réponse
                        if (findInReps !== undefined) {
                          //pas good, sélectiooné et mauvaise réponse (rouge)
                          statut = "wrong"
                        }
                      }
                    } else {
                      if (findInReps !== undefined) {
                        statut = "selected"
                      }
                    }
                  } else {
                    if (findInReps !== undefined) {
                      statut = "selected"
                    }
                  }

                  let border = "1px solid transparent"
                  let background = "white"
                  let iconBg = "transparent"
                  if (statut === "selected") {
                    border = "1px solid black"
                    background = "white"
                    iconBg = "black"
                  } else if (statut === "good") {
                    border = "1px solid #53D769"
                    background = "#eefbf0"
                    iconBg = "#53D769"
                  } else if (statut === "mustBeSelected") {
                    border = "1px solid #FED030"
                    background = "#fffae9"
                    iconBg = "#FED030"
                  } else if (statut === "wrong") {
                    border = "1px solid #FC3040"
                    background = "#ffeaec"
                    iconBg = "#FC3040"
                  }
                  return (
                    <Box
                      key={i}
                      onClick={() => {
                        handleClick(item, i)
                      }}
                      sx={{
                        border:border,
                        cursor:isAlreadyAnswer?"default":"pointer",
                        maxWidth : "600px",
                        width:"100%",
                        background:background,
                        display:"flex",
                        justifyContent:"space-between",
                      }}
                    >
                      <EditableField
                        stopClickPropagation
                        field={item?.reponse}
                        isEditor={isEditor}
                        sx={{
                          color:"text.black",
                          fontSize:["15px", "19px", "19px", "22px"],
                          padding:["20px 15px", "22px 17px", "25px 20px", "25px 20px"],
                        }}
                        type={["responses", i, "reponse"]}
                      />
                      <Box sx={{
                        marginRight:["15px", "17px", "20px", "20px"],
                        display:"flex",
                        alignItems:"center",
                      }}>
                        <Box sx={{
                          width:["22px", "25px", "35px", "40px"],
                          height:["22px", "25px", "35px", "40px"],
                          background:iconBg,
                          display:"flex",
                          alignItems:"center",
                          justifyContent:"center"
                        }}>
                          {(statut === "selected" || statut === "good" || statut === "mustBeSelected") &&
                            <CheckIcon sx={{
                              color:"white",
                              width:["12px", "15px", "17px", "22px"],
                              height:["12px", "15px", "17px", "22px"],
                            }}/>
                          }
                          {(statut === "wrong") &&
                            <CloseIcon sx={{
                              color:"white",
                              width:["12px", "15px", "17px", "22px"],
                              height:["12px", "15px", "17px", "22px"],
                            }}/>
                          }
                        </Box>
                      </Box>
                    </Box>
                  )
                })}
              </Box>
            </Box>
          </Box>
        </Box>
      </CenterContainer>
      <BottomBar
        actFormation={actFormation}
        actIndex={actIndex}
        onlyContent={isEditor ? false : onlyContent}
        isEditor={isEditor}
        buttons={
          <>
            {isAlreadyAnswer === false &&
              <EditableButton
                isEditor={false}
                disabled={responses?.length === 0}
                type="button"
                field={format?.noValidAnswer ? languageValues?.continue[actLanguage] : languageValues?.validate[actLanguage]}
                sx={{}}
                onClick={validQuizz}
              />
            }
            {isAlreadyAnswer === true &&
              <EditableButton
                isEditor={false}
                type="button"
                field={languageValues?.continue[actLanguage]}
                sx={{}}
                onClick={() => {
                  if (isEditor !== true) {
                    manageSlide(1)
                  }
                }}
              />
            }
          </>
        }
      />
    </Box>
  )
}


export default FormatQuizz
